import {AnswerTypes} from '../question/QuestionAnswer';
import {IElementQuestionAnswer} from '../../../../incase-domain/elements/base/questionElementBase';
import {IElementPhotoAnswerType} from '../../../../incase-domain/elements/question/photoAnswerQuestion';
import {ButtonColorType, buttonColorTypes} from '../../../../incase-domain/components/button/Button';
import {getColorWithAlpha} from '../../../../incase-domain/utils/utils';

export function getAnswerColor(
    answerType: AnswerTypes,
    correctColor: string | undefined,
    incorrectColor: string | undefined,
    debatableColor: string | undefined
): string {
    switch (answerType) {
        case AnswerTypes.CORRECT:
            return correctColor || 'success';
        case AnswerTypes.INCORRECT:
            return incorrectColor || 'error';
        case AnswerTypes.DEBATABLE:
            return debatableColor || 'warning';
        case AnswerTypes.SELECTED:
            return 'info';
        default:
            return 'frost';
    }
}

type AnswerTypeInput = IElementQuestionAnswer | IElementPhotoAnswerType;

export const getAnswerType = <T extends AnswerTypeInput>(answer: T): AnswerTypes => {
    if (!answer || !answer.type) {
        return AnswerTypes.NONE;
    }

    switch (answer.type) {
        case 'correct':
            return AnswerTypes.CORRECT;
        case 'incorrect':
            return AnswerTypes.INCORRECT;
        case 'debatable':
            return AnswerTypes.DEBATABLE;
        default:
            return AnswerTypes.NONE;
    }
};

export function getAnswerColors(
    answerType: AnswerTypes,
    correctColor: string | undefined,
    incorrectColor: string | undefined,
    debatableColor: string | undefined
): {
    getBtnAnswerColor: () => ButtonColorType;
    getCustomAnswerColor: () => string;
    getCustomAnswerColorWithAlpha: (alpha: number) => string;
} {
    const getBtnAnswerColor = (): ButtonColorType => {
        const btnColor = getAnswerColor(answerType, correctColor, incorrectColor, debatableColor);
        if (buttonColorTypes.includes(btnColor as ButtonColorType)) {
            return btnColor as ButtonColorType;
        }
        return 'frost';
    };

    const getCustomAnswerColor = (): string => {
        const answerColor = getAnswerColor(answerType, correctColor, incorrectColor, debatableColor);
        if (!buttonColorTypes.includes(answerColor as ButtonColorType)) {
            return answerColor;
        }
        return '';
    };

    const getCustomAnswerColorWithAlpha = (alpha: number): string => {
        const customColor = getCustomAnswerColor();
        if (customColor) {
            return getColorWithAlpha(customColor, alpha);
        }
        return '';
    };

    return {getBtnAnswerColor, getCustomAnswerColor, getCustomAnswerColorWithAlpha};
}

export function getAnswerTypeClass(answerType: AnswerTypes): string {
    switch (answerType) {
        case AnswerTypes.CORRECT:
            return 'c-button--color-success';
        case AnswerTypes.INCORRECT:
            return 'c-button--color-error';
        case AnswerTypes.DEBATABLE:
            return 'c-button--color-warning';
        case AnswerTypes.SELECTED:
            return 'c-button--color-info';
        default:
            return '';
    }
}
